import { AdminSourceSystem } from '../admin-source-system';

export interface AccountListItem {
   id: number;

   name: string;
   accountNumber: string;

   groups: number;

   users: number;

   services: AdminSourceSystem[];
}

export class AccountListItem implements AccountListItem {
   constructor( item: any = {} ) {
      this.id = item?.id;
      this.name = item?.name;
      this.accountNumber = item?.accountNumber;
      this.groups = Array.isArray( item?.groups ) ? item.groups?.length : item?.groups;
      this.users = Array.isArray( item?.users ) ? item.users?.length : item?.users;
      this.services = item?.services?.map( s => new AdminSourceSystem( s )) ?? [];
   }
}

export interface AccountUser {
   email: string;
   firstName: string;
   lastName: string;
   primary?: boolean;
}

export class AccountUser implements AccountUser {
   constructor( u: any = {} ) {
      this.email = u?.email;
      this.firstName = u?.firstName;
      this.lastName = u?.lastName;
      this.primary = u?.primary;
   }
}

export interface AccountBookingConfirmation {
   replyTo?: string;
   parties?: {
      email: string;
      currentUser?: boolean;
      recipientType: 'to' | 'cc' | 'bcc';
      brand: string;
   }[];
}

export class AccountBookingConfirmation implements AccountBookingConfirmation {
   constructor( i: any = {} ) {
      if ( i?.replyTo ) { this.replyTo = i?.replyTo; }
      if ( i?.parties ) {
         this.parties = [];
         i?.parties.map( p => this.parties.push({
            email: p?.email,
            recipientType: p?.recipientType,
            brand: p?.brand
         }));
      }
   }
}

export const AccountActions = [
   'bookingConfirmation',
   // 'appConfig',
   // 'accessDefaults',
] as const;
export type AccountActions = typeof AccountActions[number];

export interface Account {
   id: string;

   name: string;
   accountNumber: string;
   stationCode: string;

   address1: string;
   address2: string;
   city: string;
   state: string;
   postalcode: string;
   country: string;

   actions: AccountActions[];

   users?: AccountUser[];

   sourceSystems?: AdminSourceSystem[];

   bookingConfirmation?: AccountBookingConfirmation;
}

export class Account implements Account {
   constructor( a: any = {} ) {
      this.id = a?.id;

      this.name = a?.name;
      this.accountNumber = a?.accountNumber;
      this.stationCode = a?.stationCode;

      this.address1 = a?.address1;
      this.address2 = a?.address2;
      this.city = a?.city;
      this.state = a?.state;
      this.postalcode = a?.postalcode;
      this.country = a?.country;

      this.actions = a?.actions ?? [];

      if ( a?.users ) {
         this.users = a?.users.map( u => new AccountUser( u ));
      }

      if ( a?.sourceSystems ) {
         this.sourceSystems = a?.sourceSystems.map( s => new AdminSourceSystem( s ));
      }

      if ( a?.bookingConfirmation ) {
         this.bookingConfirmation = new AccountBookingConfirmation( a?.bookingConfirmation );
      }
   }
}
